(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('NewsService', NewsService);

    NewsService.$inject = ['$http', 'API_URL', 'Upload', '$log'];

    function NewsService($http, API_URL, Upload, $log) {

        var service = {
            getList: getList,
            create: create,
            remove: remove,
            uploadImage: uploadImage,
            uploadAttachment: uploadAttachment,
            removeAttachment: removeAttachment
        };

        return service;

        function getList() {
            return $http({
                method: 'GET',
                url: API_URL + 'exhibitor/news'
            });
        }

        function create(data) {
            return $http({
                method: 'POST',
                url: API_URL + 'exhibitor/news',
                data: data
            }).then(function (response) {
                return response;
            }, function (error) {
                $log.error(error);
                alert('ERROR');

                return error;
            });
        }

        function remove(id) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'exhibitor/news/' + id
            }).then(function (response) {
                return response;
            }, function (error) {
                $log.error(error);
                alert('ERROR');

                return error;
            });
        }

        function uploadImage(file) {
            var data = {
                file: file
            };

            return Upload.upload({
                url: API_URL + 'files/upload/newsimage',
                data: data
            }).then(function (response) {
                return response.data;
            });
        }

        function uploadAttachment(file) {
            var data = {
                file: file
            };

            return Upload.upload({
                url: API_URL + 'files/upload/newsattachment',
                data: data
            }).then(function (response) {
                return response.data;
            });
        }

        function removeAttachment(id) {
            return $http({
                method: 'DELETE',
                url: API_URL + 'files/' + id
            }).then(function (response) {
                return response;
            }, function (error) {
                $log.error(error);
                alert('ERROR');

                return error;
            });
        }
    }
})();
